export const mediumDateFormat = 'MMM D, y';

export const dashedDateFormat = 'yyyy-MM-DD';

export const weekFormat = '[Week] w';

export const monthFormat = 'MMMM yyyy';

export const monthNameDayYearFormat = 'MMM D, yyyy';

export function daysInMonth(month, year) {
    return 32 - new Date(year, month, 32).getDate();
}

export function dateToString(d) {
    return `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
}
